module.exports = __webpack_public_path__ + "img/alert-danger-icon.39a5b2e9.svg";